import { cn } from '@/lib/utils';

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        // `motion-reduce:animate-none` and not only the global 0.01ms override
        // in `globals.css`: that one leaves the animation *running* (once, very
        // fast), which is a different claim from "this does not move", and it is
        // the claim a test can check. Under
        // `prefers-reduced-motion: reduce` this is a still grey box.
        'animate-shimmer motion-reduce:animate-none rounded-xl bg-[linear-gradient(110deg,transparent_35%,rgb(32_29_21/7%)_50%,transparent_65%)] bg-overlay bg-[length:200%_100%]',
        className
      )}
      {...props}
    />
  );
}
